/**
 * papeis.js — checagem ÚNICA de papel no frontend (Jun/2026).
 *
 * Espelha `backend/auth/papeis.py`. O backend é quem realmente autoriza; aqui
 * só escondemos/desabilitamos controles para não oferecer ação que dará 403.
 */
export const PAPEIS_N1 = Object.freeze(["super_adm", "super_adm_empresa", "adm_empresa"]);

export function isN1(currentUser) {
  if (!currentUser) return false;
  if (currentUser.isSuperAdm === true) return true;
  return PAPEIS_N1.includes(String(currentUser.papel || "").trim());
}

/** Exportar/compartilhar relatórios (PDF · Excel · .ics). */
export const podeExportar = isN1;

/** Criar Objetivo/KR em Personalização › OKRs. */
export const podeCriarOKR = isN1;
